<template>
    <div>
        <v-dialog v-model="abrir2" persistent max-width="1000px">
            <v-card>
                <v-card-title>
                    <v-row>
                        <v-col cols="11">
                            <v-card-title class="titulopagina">{{config.titulo}}</v-card-title>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-progress-linear v-if="cargando"
                    indeterminate
                    color="blue darken-2"
                ></v-progress-linear>
                <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="2">
                            <v-text-field v-model="nombre_lote" label="N° Lote*"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-select
                                :items="estanques"
                                v-model="estanques_externos_id"
                                label="Estanque Externo"
                                item-text="nombre"
                                item-value="id"
                                class=""
                            ></v-select>
                        </v-col>
                        <v-col cols="2">
                            <date-picker type="datetime" :clearable="false" :confirme="true" v-model="fecha_produccion" format="DD-MM-YYYY" :default-value="fecha_produccion" valueType="YYYY-MM-DD"></date-picker>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field v-model="observacion" label="Observación"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-switch v-model="abierto" :label="`Lote Cerrado`"></v-switch>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-card-text>
                            <alert></alert>
                        </v-card-text>
                    </v-row>
                </v-container>
                <small>*Campos Obligatorios</small>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" dark @click="cerrar">Cerrar</v-btn>
                <v-btn color="green darken-1" dark @click="submit" :disabled="!validar">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import Alert from '@/components/shared/Alert.vue';
import { mapState } from 'vuex';
export default {
    data:()=>({
        estanques:[],
        config:{},
        lote_id:'',
        bodega:'',
        estanques_externos_id:'',
        nombre_lote:'',
        observacion:'',
        fecha_produccion:'',
        abierto:0,
        abrir2:false,
        cargando:false,
    }),
    beforeDestroy() {
        Event.$off('modalcitah');
    },
    mounted(){
        Event.$on('modalcitah',(conf)=>{
            console.log('bodega',conf);
            this.config = conf;
            this.limpiar();
            this.bodega = conf.bodega;
            this.cargarEstanquesExternos();
            this.abierto = 0;
            this.abrir2 = true;
        })
    },
    methods:{

        async submit(){
            this.cargando = true;
            console.log('enviando peticion');
            let url = ``;
            let body = {
                estanques_externos_id : this.estanques_externos_id,
                nombre_lote: this.nombre_lote,
                fecha_produccion:this.fecha_produccion,
                observacion: this.observacion,
                abierto: this.abierto == 0 ? 1 : 0,
            }
            console.log('body',body);
            if(!this.lote_id){
                /**nuevo lote */
                url = `${this.base_url}produccion_aceites/store_lote`;
                await this.axios.post(url,body,this.headers).then((res)=>{
                    this.lote_id = res.data.id;
                    if(res.data.message != "false"){                        
                        Event.$emit('actualizar_lotes_ext');
                        this.cerrar();
                    } else {
                        Event.$emit('mostrar_alert',{tipo: "success",mensaje: "Lote " + body.nombre_lote + " ya existe"});
                    }
                }).catch((error)=>{
                    console.log('error',error);
                    Event.$emit('mostrar_alert',{tipo: "error",mensaje: (error.message ? error.message : error)});
                })
            }else{
                /**actualización */
                url = `${this.base_url}produccion_aceites/store_lote/${this.lote_id}`;
                await this.axios.put(url,body,this.headers).then((res)=>{
                    Event.$emit('mostrar_alert',{tipo: "success",mensaje: res.data.message});

                    Event.$emit('actualizar_lotes_ext');
                    this.cerrar();
                }).catch((error)=>{
                    console.log('error',error);
                    Event.$emit('mostrar_alert',{tipo: "error",mensaje: (error.message ? error.message : error)});
                })
            }
            this.cargando = false;
        },

        limpiar(){
            this.estanques_externos_id = '';
            this.fecha_produccion = this.moment().format('YYYY-MM-DD');
            this.nombre_lote = '';
            this.observacion = '';
            this.abierto = 1;
        },

        regexTest(string){
            let patt = new RegExp(/[^R\-0-9]+/g);
            let res = patt.test(string);
            return res;
        },

        async cargarEstanquesExternos(){
            await this.axios.get(`${this.base_url}estanques_externos?bodega=${this.bodega}`,this.headers).then((response)=>{
                this.estanques = response.data.data;
                this.cargando = false;
                console.log('estanques',response.data.data);
            }).catch((error)=>{
                console.log('error',error);
                this.cargando = false;
            });
        },
        cerrar() {
            this.$parent.$emit('cargar_lotes');    
            this.abrir2 = false;
        },
    },
    computed:{
        lotes_abiertos(){
            if(this.estanques_externos_id){
                return this.lotes.filter(a=>a.estanques_externos_id == this.estanques_externos_id);
            }else{
                return [];
            }
        },
        validar(){
            if(this.estanques_externos_id && this.nombre_lote){
                return true;
            }else{
                return false;
            }
        },
        ...mapState(['base_url','headers'])
    },
    components:{
        'alert':Alert,
        DatePicker,
    }
}
</script>
<style>
.hidden{
    display: none;
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
    background: #d2d6d8 !important;
    color: #212121 !important;
}
</style>